@if (value() === null || value() === undefined) {
  <div class="indicator">
    <mat-icon class="rotate-animation loading-icon">cached</mat-icon>
  </div>
} @else if (value() || isDisplayWhenZero()) {
  <div class="indicator">
    {{ value() }}
  </div>
}
